export const surveyDeskApiUrl =
  window.location.host.indexOf('test01.riwis.de') >= 0
    ? 'https://survey-desk-services.test01.riwis.de/api'
    : window.location.host === 'survey-desk.bulwiengesa-solutions.de'
    ? 'https://survey-desk-services.bulwiengesa-solutions.de/api'
    : process.env.REACT_APP_SERVICES_LOCAL === 'true'
    ? // ? 'http://localhost:3005/api'
      `http://${window.location.hostname}:3005/api`
    : 'survey-desk-ng.test01.riwis.de/api'
